import { useMutation } from '@tanstack/react-query'
import { authService } from '../../../api/api-auth'
import { mutationHandler } from '../../../utils/mutationHandler'

export const useReset2fa = (id: string) => {
  return useMutation(['reset2fa'], () => authService.reset2FA(id), mutationHandler({}))
}
